import Box from "@mui/material/Box";
import { FC } from "react";
import { RedRepairIcon } from "shared/theme/icons/RedRepairIcon";
import { StyledNavItemTypography } from "../../../../styled";
import {
  StyledDot,
  StyledDotContainer,
  StyledIconContainer,
  StyledSubItemLink,
} from "./styled";

type Props = {
  pathname: string;
  title: string;
  active: boolean;
  isMaintenanceMode?: boolean;
};

export const NavSubItemLink: FC<Props> = ({
  pathname,
  title,
  active,
  isMaintenanceMode,
}) => {
  return (
    <StyledSubItemLink to={pathname} active={active}>
      <StyledDotContainer>
        <StyledDot active={active} />
      </StyledDotContainer>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <StyledNavItemTypography active={active}>
          {title}
        </StyledNavItemTypography>
        {isMaintenanceMode && (
          <StyledIconContainer>
            <RedRepairIcon />
          </StyledIconContainer>
        )}
      </Box>
    </StyledSubItemLink>
  );
};
